/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React from 'react';

import Fade from 'react-reveal/Fade';
import Button from 'elements/Button';

export default function Solutions({ data }) {
  return (
    <section className="container mx-auto py-24">
      <Fade bottom>
        <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-16">
          AI-Powered Virtual Assistants For
          {' '}
          <br />
          Business Optimization & Automation
        </h2>
      </Fade>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-16 px-4">
        {data.map((solution, index) => (
          <Fade bottom delay={300 * index} key={solution.title}>
            <div className="group relative bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden transform transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl">
              {/* Decorative background gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-theme-purple/5 via-transparent to-dark-theme-purple/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              {/* Decorative corner element */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-theme-purple/10 to-transparent rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              <div className="relative p-8 z-10">
                <div className="flex items-center mb-4">
                  <div className="relative w-16 h-16 bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 rounded-xl flex items-center justify-center mr-4 group-hover:from-theme-purple/20 group-hover:to-dark-theme-purple/20 transition-all duration-300">
                    <img src={solution.imageUrl} alt={solution.title} className="w-10 h-10 object-contain transform transition-transform duration-300 group-hover:scale-110" />
                    {/* Animated ring on hover */}
                    <div className="absolute inset-0 rounded-xl border-2 border-theme-purple/30 opacity-0 group-hover:opacity-100 group-hover:animate-ping transition-opacity duration-300" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-theme-blue group-hover:text-theme-purple transition-colors duration-300">{solution.title}</h3>
                    <p className="text-sm text-gray-500 mt-1">{solution.subtitle}</p>
                  </div>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">{solution.description}</p>
                <Button href="/discuss-project" type="link" className="w-full text-center bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white px-6 py-3 rounded-lg hover:shadow-lg transform transition-all duration-300 hover:scale-105 relative overflow-hidden group/btn">
                  <span className="relative z-10">Learn More</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-dark-theme-purple to-theme-purple opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300" />
                </Button>
              </div>
            </div>
          </Fade>
        ))}
      </div>
    </section>
  );
}
